import {AlertIcon} from '@primer/octicons-react'
import {Flash} from '@primer/react'

import styles from './SpoofedCommitWarning.module.css'
import {useLatestCommitContext} from '../contexts/LatestCommitContext'

export function SpoofedCommitWarning() {
  const {latestCommit} = useLatestCommitContext()
  const isSpoofed = latestCommit?.isSpoofed ?? false

  if (!isSpoofed) {
    return null
  }

  return <SpoofedCommitWarningBanner className={styles.SpoofedCommitWarningBanner} />
}

export function SpoofedCommitWarningBanner({className}: {className?: string}) {
  return (
    <Flash variant="warning" className={className} data-testid="spoofed-commit-warning-banner">
      <AlertIcon />
      <span>
        This commit does not belong to any branch on this repository, and may belong to a fork outside of the
        repository.
      </span>
    </Flash>
  )
}
